export enum DOCUMENT_DOWNLOAD_SIGNIN_STATUS_ENUM {
  SIGNED = "signed",
  NOT_SIGNED = "not_signed",
};
